import React, { useContext, useEffect } from "react";
import { FoldingContentContext } from "../../../../../../../components/folding/FoldingContent";
import DetailsLayout from "../layouts/DetailsLayout";
import DeploymentLogs from "../../../../../../dashboard/cells/actions/components/DeploymentLogs";

export default function BuilderDeploymentLogs({deployment, deploymentLoading, custom}) {

    const foldingContext = useContext(FoldingContentContext);

    useEffect(() => {
        if (foldingContext) setTimeout(() => foldingContext?.recalculateHeight(), 100);
        window.addEventListener('storage', () => {
            if (foldingContext) foldingContext?.recalculateHeight();
        })
    }, []);

    useEffect(() => {
        if (custom && !deploymentLoading && foldingContext) {
            setTimeout(() => foldingContext?.recalculateHeight(), 100);
        }
    }, [deploymentLoading]);

    return (
            <DetailsLayout title='Logs' icon='fas fa-code' folded={true}>
                <DeploymentLogs
                    deployment={deployment}
                    deploymentLoading={deploymentLoading}
                    custom
                />
            </DetailsLayout>
    )

}